routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.tracking', {
      url: __env.routes.tracking,
      template: `<tracking sh-ctrl="shCtrl"></tracking>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/orders/tracking/tracking.confing.js